import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../../common/profileCard";
import StudentSidebar from "../../common/studentSidebar";
import { useTranslation } from "react-i18next";
import {
  Button,
  Radio,
  Progress,
  Card,
  Space,
  Typography,
  Spin,
  Modal,
} from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useHandleQuiz } from "../../../../core/hooks/useHandleQuiz";
import {
  countQuizPages,
  extractQuizReview,
} from "../../../../core/common/ults/domParser";
import { CustomEditor } from "../../../../core/common/ults/editor";
import { all_routes } from "../../../router/all_routes";
import { MathText } from "../../../../core/common/ults/MathText";
import { QuizQuestionContent } from "../../../../core/common/ults/QuizQuestionContent";

const { Title } = Typography;

const StudentQuizReview = () => {
  const { t } = useTranslation();
  const route = all_routes;
  const id = Number(useParams().id);
  const location = useLocation();
  const { quizName, totalgrade } = location.state || {};
  const [page, setPage] = useState(0);
  const { quizAttemptReview, isQuizAttemptReviewLoading } = useHandleQuiz({
    attemptid: id,
    page: page,
  });
  const navigate = useNavigate();

  const totalQuizQuestions = countQuizPages(quizAttemptReview?.attempt?.layout);

  const quizReview = extractQuizReview(
    quizAttemptReview?.questions?.[0]?.type,
    quizAttemptReview?.questions?.[0]?.html
  );

  console.log(quizReview);

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState<number | null>(null);
  const [answers, setAnswers] = useState<number[]>([]);
  const [answeredQuestions, setAnsweredQuestions] = useState<Set<number>>(
    new Set()
  );
  // Thêm useEffect để khởi tạo selectedAnswer từ quizQuestionAndAnswer
  useEffect(() => {
    if (
      quizReview?.selectedAnswerIndex !== null &&
      quizReview?.selectedAnswerIndex !== undefined
    ) {
      setSelectedAnswer(quizReview.selectedAnswerIndex);
      // Cập nhật answers array với selectedAnswerIndex
      const newAnswers = [...answers];
      newAnswers[currentQuestion] = quizReview.selectedAnswerIndex;
      setAnswers(newAnswers);
      // Cập nhật answeredQuestions
      setAnsweredQuestions(
        (prev) => new Set(Array.from(prev).concat(currentQuestion))
      );
    } else {
      // Nếu không có selectedAnswerIndex, sử dụng giá trị từ answers array
      setSelectedAnswer(answers[currentQuestion] || null);
    }
  }, [quizReview?.selectedAnswerIndex, currentQuestion]);

  // useEffect riêng để theo dõi selectedAnswer và cập nhật answeredQuestions
  useEffect(() => {
    if (selectedAnswer !== null && selectedAnswer !== undefined) {
      setAnsweredQuestions(
        (prev) => new Set(Array.from(prev).concat(currentQuestion))
      );
    }
  }, [selectedAnswer, currentQuestion]);

  const handleAnswerSelect = (value: number) => {
    setSelectedAnswer(value);
    const newAnswers = [...answers];
    newAnswers[currentQuestion] = value;
    setAnswers(newAnswers);
    // Cập nhật answeredQuestions
    setAnsweredQuestions(
      (prev) => new Set(Array.from(prev).concat(currentQuestion))
    );
  };

  const handleNext = async () => {
    if (currentQuestion < totalQuizQuestions - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setPage(currentQuestion + 1);
      setSelectedAnswer(answers[currentQuestion + 1] || null);
    }
  };

  const handlePrevious = async () => {
    if (currentQuestion > 0) {
      // Không submit answer nữa
      setCurrentQuestion(currentQuestion - 1);
      setPage(currentQuestion - 1);
      setSelectedAnswer(answers[currentQuestion - 1] || null);
    }
  };

  const handleQuestionSelect = async (index: number) => {
    // Không submit answer nữa
    setCurrentQuestion(index);
    setPage(index);
    setSelectedAnswer(answers[index] || null);
  };

  const getQuestionButtonType = (index: number) => {
    if (index === currentQuestion) return "primary";
    if (answers[index] !== undefined) return "default";
    return "dashed";
  };

  const getQuestionButtonStyle = (index: number) => {
    const baseStyle = { width: "40px", height: "40px" };

    if (index === currentQuestion) {
      // Câu hỏi hiện tại - màu xanh primary
      return {
        ...baseStyle,
        backgroundColor: "#1890ff",
        borderColor: "#1890ff",
        color: "white",
      };
    }

    // Kiểm tra xem câu hỏi đã có câu trả lời chưa
    const hasAnswer = answeredQuestions.has(index);

    if (hasAnswer) {
      // Câu hỏi đã có câu trả lời - màu xanh lá
      return {
        ...baseStyle,
        backgroundColor: "#52c41a",
        borderColor: "#52c41a",
        color: "white",
      };
    }

    // Câu hỏi chưa trả lời - màu xám nhạt
    return {
      ...baseStyle,
      backgroundColor: "#f5f5f5",
      borderColor: "#d9d9d9",
      color: "#666",
    };
  };

  // Kiểm tra lỗi từ quizAttemptReview
  const errorMessage =
    quizAttemptReview?.message ||
    quizAttemptReview?.exception ||
    quizAttemptReview?.errorcode ||
    quizAttemptReview?.debuginfo;
  const isError = Boolean(errorMessage);

  return (
    <>
      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <Breadcrumb title={t("quiz.title")} />

              <Card className="quiz-container">
                <div className="header-wrapper d-flex mb-3 justify-content-between align-items-center">
                  <h5>{quizName}</h5>
                  <div>
                    <Button
                      type="primary"
                      onClick={() => navigate(route.studentQuiz)}
                    >
                      Quay lại
                    </Button>
                  </div>
                </div>
                {isError ? (
                  <div style={{ margin: "32px 0", textAlign: "center" }}>
                    <Typography.Text
                      type="danger"
                      style={{ fontSize: 18, fontWeight: 600 }}
                    >
                      {quizAttemptReview?.message ||
                        "Bạn không được phép xem lại bài kiểm tra này hoặc đã xảy ra lỗi."}
                    </Typography.Text>
                  </div>
                ) : (
                  <>
                    <div className="quiz-header">
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <Title level={4}>
                            Câu hỏi {currentQuestion + 1}/{totalQuizQuestions}
                          </Title>
                          <div>
                            Điểm {quizAttemptReview?.grade}/{totalgrade}
                          </div>
                        </div>
                        <Progress
                          percent={
                            ((currentQuestion + 1) / totalQuizQuestions) * 100
                          }
                          showInfo={false}
                        />
                      </Space>
                    </div>
                    <Spin spinning={isQuizAttemptReviewLoading}>
                      {/* Thêm thanh điều hướng nhanh các câu hỏi */}
                      <div className="question-navigation mt-3 mb-4">
                        <Space wrap>
                          {Array.from(
                            { length: totalQuizQuestions },
                            (_, index) => (
                              <Button
                                key={index}
                                type={getQuestionButtonType(index)}
                                onClick={() => handleQuestionSelect(index)}
                                style={getQuestionButtonStyle(index)}
                              >
                                {index + 1}
                              </Button>
                            )
                          )}
                        </Space>
                      </div>

                      <div className="quiz-content mt-4">
                        <Title level={5}>
                          <QuizQuestionContent
                            html={quizReview?.question}
                            imageSrcs={quizReview?.questionImageSrcs}
                          />
                        </Title>
                        {quizAttemptReview?.questions?.[0]?.type ===
                          "essay" && (
                          <CustomEditor
                            value={quizReview?.essayResponse || ""}
                            // onEditorChange={handleEditorChange}
                            disabled
                            id="message"
                          />
                        )}
                        <Radio.Group
                          onChange={(e) => handleAnswerSelect(e.target.value)}
                          value={selectedAnswer}
                          disabled
                          style={{ pointerEvents: "none" }}
                        >
                          <Space direction="vertical">
                            {quizReview?.answers?.map((option, index) => (
                              <Radio
                                key={index}
                                value={index}
                                style={{ color: "#000", opacity: 1 }}
                              >
                                <MathText text={option?.text} isHtml />
                              </Radio>
                            ))}
                          </Space>
                        </Radio.Group>
                        {/* Thông tin trạng thái và đáp án đúng */}
                        <div style={{ marginTop: 16, textAlign: "left" }}>
                          <div style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 500 }}>
                              Trạng thái:&nbsp;
                            </span>
                            <span>
                              {quizReview?.status === "correct" ? (
                                <span
                                  style={{ color: "#52c41a", fontWeight: 600 }}
                                >
                                  Đúng
                                </span>
                              ) : quizReview?.status === "incorrect" ? (
                                <span
                                  style={{ color: "#ff4d4f", fontWeight: 600 }}
                                >
                                  Sai
                                </span>
                              ) : (
                                <span
                                  style={{ color: "#faad14", fontWeight: 600 }}
                                >
                                  Chưa chấm
                                </span>
                              )}
                            </span>
                          </div>
                          <div>
                            <span style={{ fontWeight: 500 }}>
                              Câu trả lời đúng:&nbsp;
                            </span>
                            <span style={{ color: "#52c41a", fontWeight: 600 }}>
                              <MathText text={quizReview?.correctAnswer} isHtml />
                            </span>
                          </div>
                          {quizReview?.generalFeedback && (
                            <div style={{ marginTop: 8 }}>
                              <span style={{ fontWeight: 500 }}>
                                Giải thích:&nbsp;
                              </span>
                              <span>
                                <MathText text={quizReview.generalFeedback} isHtml />
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="quiz-footer mt-4">
                        <Space>
                          <Button
                            onClick={handlePrevious}
                            disabled={currentQuestion === 0}
                          >
                            Câu trước
                          </Button>
                          <Button
                            type="primary"
                            onClick={handleNext}
                            disabled={currentQuestion === totalQuizQuestions}
                          >
                            Câu tiếp theo
                          </Button>
                        </Space>
                      </div>
                    </Spin>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentQuizReview;
